// (function ($) {
  /*
  Place your custom JavaScript code in this file.
  It will be loaded on the pages where your form is displayed.
  The file is saved in your theme folder: //Applications/XAMPP/xamppfiles/htdocs/sorling/web/app/themes/sorling/resources/js/reklamation.js  */

  const complaintGoodsAutoCompute = function (event, input) {
    if (event.isComposing || event.key === 229) {
      return;
    }

    const parentRow = input.closest('.form-group-row');
    const quantityValue = parentRow.querySelector('input.quantity').value.trim();
    const unitPriceValue = parentRow.querySelector('input.unit-price').value.trim();
    const formWrapper = parentRow.closest('.complaint-goods');

    calculateAmountSum(formWrapper, parentRow, quantityValue, unitPriceValue);
  };

  const installationWorksAutoCompute = function (event, input) {
    if (event.isComposing || event.key === 229) {
      return;
    }

    const parentRow = input.closest('.form-group-row');

    const timeValue = parentRow.querySelector('input.time').value.trim();
    const unitPriceValue = parentRow.querySelector('input.unit-price').value.trim();
    console.log(unitPriceValue);
    const formWrapper = parentRow.closest('.installation-works');

    calculateAmountSum(formWrapper, parentRow, timeValue, unitPriceValue);
  };

  function calculateAmountSum(formWrapper, parentRow, input1, input2) {
    const amountField = parentRow.querySelector('.amount');

    if ( input1.length > 0 && input2.length > 0 ) {
      amountField.innerHTML = input1 * input2;
    } else {
      amountField.innerHTML = 0;
    }

    let total = 0;
    Array.prototype.slice.call(formWrapper.querySelectorAll('.amount')).forEach(function (amount) {
      total += parseInt(amount.innerHTML);
    });

    formWrapper.querySelector('.total-amount').innerHTML = total;
    formWrapper.querySelector('.total-amount-val').value = total;
  }

  const complaintGoodsQuantityInput = document.querySelectorAll('.complaint-goods .form-group-row .quantity');
  Array.prototype.slice.call(complaintGoodsQuantityInput).forEach(function (input) {
    input.addEventListener('keyup', function(event){
      complaintGoodsAutoCompute(event, input);
    });
  });

  const complaintGoodsUnitPriceInput = document.querySelectorAll('.complaint-goods .form-group-row .unit-price');
  Array.prototype.slice.call(complaintGoodsUnitPriceInput).forEach(function (input) {
    input.addEventListener('keyup', function(event){
      complaintGoodsAutoCompute(event, input);
    });
  });

  const installationWorksTimeInput = document.querySelectorAll('.installation-works .form-group-row .time');
  Array.prototype.slice.call(installationWorksTimeInput).forEach(function (input) {
    input.addEventListener('keyup', function(event){
      installationWorksAutoCompute(event, input);
    });
  });

  const installationWorksUnitPriceInput = document.querySelectorAll('.installation-works .form-group-row .unit-price');
  Array.prototype.slice.call(installationWorksUnitPriceInput).forEach(function (input) {
    input.addEventListener('keyup', function(event){
      installationWorksAutoCompute(event, input);
    });
  });
// })(jQuery);



// WEBPACK FOOTER //
// resources/assets/scripts/reklamation.js